import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useAuthz } from '@/features/auth/hooks/useAuthz'
import type { PermissionCode } from '@/features/auth/types'

interface Props {
  permission: PermissionCode
  children: ReactNode
}

/** Fail-closed route guard. AuthGate has already resolved `/api/me` before this renders. */
export default function RequirePermissionRoute({ permission, children }: Props) {
  const { can } = useAuthz()

  if (!can(permission)) {
    return (
      <div role="alert" className="flex h-64 flex-col items-center justify-center gap-3 text-center">
        <ShieldAlert size={24} className="text-gray-400" />
        <p className="text-sm font-semibold text-gray-700">You don't have access to this.</p>
        <Link to="/" className="text-xs font-medium text-primary hover:underline">Back to Home</Link>
      </div>
    )
  }

  return <>{children}</>
}
